import React, { useState } from 'react'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'

import {
  ShowFiltersButton,
  SelectedFiltersList,
  FilterItem,
  ClearFiltersButton,
  ButtonPart,
  LabelList,
} from './FiltersArea.styles'
import { Filter } from '../../pages/AssetsPage/CustomersList'
import FiltersAreaContainer from '../../styles/FiltersAreaContainer'

const FiltersArea: React.FC<{
  filters?: Filter[]
  onFilterDeleteClick: (filter: Filter) => void
  clearFilters: () => void
  labelBackgroundColor?: string
  labelTextColor?: string
  linkColor?: string
  linkHoverColor?: string
}> = ({
  children,
  filters,
  onFilterDeleteClick,
  clearFilters,
  labelBackgroundColor,
  labelTextColor,
  linkColor,
  linkHoverColor,
}) => {
  const [showFilters, setShowFilters] = useState(true)
  const { t } = useTranslation()

  const labelsList = (
    <SelectedFiltersList filtersVisible={showFilters} data-testid="filter-list">
      {filters?.map((filter, i) => (
        <FilterItem key={i} backgroundColor={labelBackgroundColor} textColor={labelTextColor}>
          {filter.filter}
          <button
            onClick={() => onFilterDeleteClick(filter)}
            aria-label={`${t('delete')} ${filter.filter}`}
          >
            <Icon icon={faTimes} color={labelTextColor ? labelTextColor : 'white'} />
          </button>
        </FilterItem>
      ))}
      {filters && filters.length > 1 && (
        <ClearFiltersButton
          textColor={linkColor}
          hoverColor={linkHoverColor}
          onClick={clearFilters}
        >
          {t('clear_all')}
        </ClearFiltersButton>
      )}
    </SelectedFiltersList>
  )

  return (
    <>
      <ButtonPart>
        <ShowFiltersButton
          textColor={linkColor}
          hoverColor={linkHoverColor}
          onClick={() => setShowFilters((s) => !s)}
        >
          {showFilters ? t('hide_filters') : t('show_filters')}
        </ShowFiltersButton>
      </ButtonPart>
      {showFilters ? (
        <FiltersAreaContainer>
          {showFilters && children}
          {labelsList}
        </FiltersAreaContainer>
      ) : (
        <LabelList>{labelsList}</LabelList>
      )}
    </>
  )
}

export default FiltersArea
